import { Flex, type FlexProps, Spinner, isNumber } from "@hopper-ui/components";
import { useEffect, useState } from "react";

interface PageLoaderProps extends LoaderProps, Omit<FlexProps, "aria-label" | "children"> {}

export function PageLoader({ delay, "aria-label": ariaLabel, ...rest }: PageLoaderProps) {
    return (
        <Flex height="100%" padding="inset-lg" alignItems="center" justifyContent="center" {...rest}>
            <Loader aria-label={ariaLabel} delay={delay} />
        </Flex>
    );
}

interface LoaderProps {
    delay?: false | number;
    "aria-label": string;
}

const DefaultLoaderDelay = 300;

function Loader({ delay, "aria-label": ariaLabel }: LoaderProps) {
    const [isShown, setIsShown] = useState<boolean>(!delay);

    useEffect(() => {
        if (!delay) {
            return;
        }

        const showTimer = setTimeout(() => setIsShown(true), isNumber(delay) ? delay : DefaultLoaderDelay);

        return () => clearTimeout(showTimer);
    }, [delay]);

    return isShown && <Spinner aria-label={ariaLabel} />;
}
